<div class="banner d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mt-3 py-3 py-lg-0">
  <h3 class="text-nowrap">
    Welcome @if (!userName) {
    <span>to NRC!</span>
    }
    @if (userName) {
    <span>{{ userName }}</span>
    }
  </h3>

  @if (showAdminBanner) {
  <div id="carouselExampleFade" class="carousel slide px-3 px-lg-5 carousel-fade ms-lg-auto me-lg-5"
    data-bs-ride="carousel">
    <div class="carousel-inner">
      <div [innerHTML]="message" class="carousel-item active small"></div>
    </div>
  </div>
  } @else {
  <div class="breeze-banner-container px-3 px-lg-5 ms-lg-auto me-lg-5">
    <!-- <img src="assets/landing-page-assets/SecurePay.png"  -->
    <img src="assets/landing-page-assets/ticket-notice.png" alt="Official ticket channels notice"
      class="breeze-banner-img" />
    <!-- <img src="assets/peak-ad.png" alt="Pay with transfer on Breeze - Super Fast" class="breeze-banner-img" /> -->
  </div>
  }

  <!-- <div
*ngIf="isMoreThanTwoWeeks"
class="breeze-banner-container px-3 px-lg-5 ms-lg-auto me-lg-5"
>
<img
  ngSrc="assets/landing-page-assets/securre.gif"
  alt="Pay with transfer on Breeze - Super Fast"
  class="breeze-banner-img"
  width="700"
  height="200"
  />
</div> -->

  <div class="gif-container d-none d-lg-block">
    <img ngSrc="assets/spinning-globe.gif" width="92" height="92" alt="" class="w-100" />
  </div>
</div>

<form class="container-fluid">
  <section class="radio-options">
    <div class="form-check form-check-inline">
      <input id="one-way" checked class="form-check-input" type="radio" name="radioGroup" />
      <label for="one-way" class="form-check-label">One Way</label>
    </div>
    <div class="form-check form-check-inline" (click)="displayComingSoon()">
      <input id="round-trip" disabled class="form-check-input" type="radio" name="radioGroup" />
      <label for="round-trip" class="form-check-label">Round Trip</label>
    </div>
    <div class="form-check form-check-inline" (click)="displayComingSoon()">
      <input id="multi" disabled class="form-check-input" type="radio" name="radioGroup" />
      <label for="multi" class="form-check-label">Multi City</label>
    </div>
  </section>


  @if (isMobile) {
  <div [formGroup]="form">
    <div class="mobile-box" ngbDropdown #stationDropdown="ngbDropdown">
      <div ngbDropdownToggle>
        <div class="form-floating station-floating m-2">
          <input readonly formControlName="sourceStationName" type="text" class="form-control station-input" />
          <label for="floatingInput">From</label>
        </div>
      </div>
      @if (readonly == false) {
      <div ngbDropdownMenu>
        <ng-container>
          <h6 class="recent-places">ABUJA - KADUNA</h6>
          <div class="station-names-holder">
            @for (station of lineStations1; track station; let i = $index) {
            <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{ station.stationName
              | titlecase }}</span>
            }
          </div>
        </ng-container>
        @if (lineStations2.length > 0) {
        <h6 class="recent-places">LAGOS - IBADAN</h6>
        <div class="station-names-holder">
          @for (station of lineStations2; track station; let i = $index) {
          <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{ station.stationName |
            titlecase }}</span>
          }
        </div>
        }
        @if (lineStations3.length > 0) {
        <h6 class="recent-places">WARRI - ITAKPE</h6>
        <div class="station-names-holder">
          @for (station of lineStations3; track station; let i = $index) {
          <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{ station.stationName |
            titlecase }}</span>
          }
        </div>
        }
      </div>
      }
    </div>
    <div class="position-relative">
      @if (readonly == false) {
      <img (click)="onSwapStations()" class="swap mobile" src="/assets/landing-page-assets/swap-1.svg"
        alt="swap icon" />
      }
    </div>
    <div class="mobile-box" ngbDropdown #destinationDropdown="ngbDropdown">
      <div ngbDropdownToggle>
        <div class="form-floating station-floating m-2">
          <input readonly formControlName="destinationStationName" type="text" class="form-control station-input" />
          <label for="floatingInput">To</label>
        </div>
      </div>
      @if (source?.value && readonly == false) {
      <div ngbDropdownMenu>
        @if (route == 0 || route == 1) {
        <h6 class="recent-places">ABUJA - KADUNA</h6>
        <div class="station-names-holder">
          @for (station of lineStations1; track station; let i = $index) {
          <span (click)="updateDestination(station); destinationDropdown.close()" class="station-names">{{
            station.stationName | titlecase }}</span>
          }
        </div>
        }
        @if ((route == 0 || route == 2) && lineStations2.length > 0) {
        <h6 class="recent-places">LAGOS - IBADAN</h6>
        <div class="station-names-holder">
          @for (station of lineStations2; track station; let i = $index) {
          <span (click)="updateDestination(station); destinationDropdown.close()" class="station-names">{{
            station.stationName | titlecase }}</span>
          }
        </div>
        }
        @if ((route == 0 || route == 3) && lineStations3.length > 0) {
        <h6 class="recent-places">WARRI - ITAKPE</h6>
        <div class="station-names-holder">
          @for (station of lineStations3; track station; let i = $index) {
          <span (click)="updateDestination(station); destinationDropdown.close()" class="station-names">{{
            station.stationName | titlecase }}</span>
          }
        </div>
        }
      </div>
      }
    </div>
    <div class="mobile-box">
      <div>
        <div (click)="readonly ? null : d.toggle()">
          <!-- <p>Depart</p> -->
          <p class="date-value-holder">
            {{ depatureDate?.value | date: "d LLL yyyy" }}
          </p>
        </div>
        <input ngbDatepicker #d="ngbDatepicker" (dateSelect)="onDateSelected($event)" name="datepicker"
          [startDate]="minDepatureDate" [outsideDays]="'hidden'" [navigation]="'arrows'" [minDate]="minDepatureDate"
          [maxDate]="maxDepatureDate" [markDisabled]="datePickerDisabled" [hidden]="" tabindex="-1" [autoClose]="true"
          class="date-picker" />
      </div>
    </div>
    <div class="mobile-box">
      <div>
        <div ngbDropdown>
          <div ngbDropdownToggle class="search-text">
            <div class="row align-items-center flex-column">
              <div class="col">
                <p>Class</p>
                <p>
                  {{ form.value.price }}
                </p>
              </div>
              <div class="d-flex align-items-center">
                <img src="assets/horizontal-line.svg" alt="" class="flex-grow-1" />
                <img src="/assets/landing-page-assets/ArrowUp.svg" alt="add button" />
              </div>
              <div class="col">
                <p>Passengers</p>
                <p>{{ adult?.value + minor?.value }} Guest <span> </span></p>
              </div>
            </div>
          </div>
          @if (readonly == false) {
          <div class="passenger-dropdown" ngbDropdownMenu>
            <h6 class="dropdown-header">No. of Adults</h6>
            <div class="col-md-8 d-flex justify-content-between align-items-center">
              <button type="button" (click)="onDecreaseAdults()" class="btn">
                <img src="../../../../assets/minus-btn.svg" alt="minus button" class="img-fluid" />
              </button>
              <p class="mb-0">{{ adult?.value }}</p>
              <button (click)="onIncreaseAdults()" type="button" class="btn">
                <img src="../../../../assets/add-btn.svg" alt="add button" class="img-fluid" />
              </button>
            </div>
            <h6 class="dropdown-header">No. of Minors, Age 3 to 15</h6>
            <div class="col-md-8 d-flex justify-content-between align-items-center mb-3">
              <button type="button" (click)="onDecreaseMinors()" class="btn">
                <img src="../../../../assets/minus-btn.svg" alt="minus button" class="img-fluid" />
              </button>
              <p class="mb-0">{{ minor?.value }}</p>
              <button (click)="onIncreaseMinors()" type="button" class="btn">
                <img src="../../../../assets/add-btn.svg" alt="add button" class="img-fluid" />
              </button>
            </div>
            <ul class="list-group list-group-flush">
              @for (price of prices; track price; let i = $index) {
              <li class="list-group-item">
                <label class="form-check-label d-flex align-items-center justify-content-between"
                  for="pricelist-{{ i }}" role="button">{{ price.name | uppercase }}
                  <input formControlName="price" class="form-check-input" role="button" [value]="price.name"
                    type="radio" name="price" id="pricelist-{{ i }}" /></label>
              </li>
              }
            </ul>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div [formGroup]="form" class="search">
    <div class="from">
      <!-- Source starts here!!! -->
      <div ngbDropdown #stationDropdown="ngbDropdown">
        <div ngbDropdownToggle class="h-100 d-flex align-items-center">
          <div class="station-floating m-2">
            <label for="floatingInput">From</label>
            <input readonly formControlName="sourceStationName" type="text" class="form-control station-input p-0" />
          </div>
        </div>
        @if (readonly == false) {
        <div ngbDropdownMenu>
          <ng-container>
            <h6 class="recent-places">ABUJA - KADUNA</h6>
            <div class="station-names-holder">
              @for (station of lineStations1; track station; let i = $index) {
              <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{
                station.stationName | titlecase }}</span>
              }
            </div>
          </ng-container>
          @if (lineStations2.length > 0) {
          <h6 class="recent-places">LAGOS - IBADAN</h6>
          <div class="station-names-holder">
            @for (station of lineStations2; track station; let i = $index) {
            <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{ station.stationName
              | titlecase }}</span>
            }
          </div>
          }
          @if (lineStations3.length > 0) {
          <h6 class="recent-places">WARRI - ITAKPE</h6>
          <div class="station-names-holder">
            @for (station of lineStations3; track station; let i = $index) {
            <span (click)="updateSource(station); stationDropdown.close()" class="station-names">{{ station.stationName
              | titlecase }}</span>
            }
          </div>
          }
        </div>
        }
      </div>
      <!-- Source ends here!!! -->
      <!-- swap button starts here!!! -->
      <div class="util">
        <div class="vr"></div>
        @if (readonly == false) {
        <img (click)="onSwapStations()" class="swap" src="/assets/landing-page-assets/swap-1.svg" alt="swap icon" />
        }
      </div>
      <!-- swap button ends here!!! -->
      <!-- Destination input starts here -->
      <div ngbDropdown #destinationDropdown="ngbDropdown">
        <div ngbDropdownToggle class="h-100 d-flex align-items-center">
          <div class="station-floating m-2">
            <label for="floatingInput">To</label>
            <input readonly formControlName="destinationStationName" type="text"
              class="form-control station-input p-0" />
          </div>
        </div>
        @if (source?.value && readonly == false) {
        <div ngbDropdownMenu>
          @if (route == 0 || route == 1) {
          <h6 class="recent-places">ABUJA - KADUNA</h6>
          <div class="station-names-holder">
            @for (station of lineStations1; track station; let i = $index) {
            <span (click)="
                    updateDestination(station); destinationDropdown.close()
                  " class="station-names">{{ station.stationName |
              titlecase }}</span>
            }
          </div>
          }
          @if ((route == 0 || route == 2) && lineStations2.length > 0) {
          <h6 class="recent-places">LAGOS - IBADAN</h6>
          <div class="station-names-holder">
            @for (station of lineStations2; track station; let i = $index) {
            <span (click)="
                    updateDestination(station); destinationDropdown.close()
                  " class="station-names">{{ station.stationName |
              titlecase }}</span>
            }
          </div>
          }
          @if ((route == 0 || route == 3) && lineStations3.length > 0) {
          <h6 class="recent-places">WARRI - ITAKPE</h6>
          <div class="station-names-holder">
            @for (station of lineStations3; track station; let i = $index) {
            <span (click)="
                    updateDestination(station); destinationDropdown.close()
                  " class="station-names">{{ station.stationName |
              titlecase }}</span>
            }
          </div>
          }
        </div>
        }
      </div>
      <!-- Destination input ends here -->
    </div>
    <div class="depart">
      <!-- Depart date starts here -->
      <div class="search-text">
        <div class="date-box" (click)="readonly ? null : d.toggle()">
          <p>Depart</p>
          <p>
            {{ depatureDate?.value | date: "d LLL yyyy" }}
          </p>
          <p>
            {{ depatureDate?.value | date: "EEEE" }}
          </p>
        </div>
        <input ngbDatepicker #d="ngbDatepicker" (dateSelect)="onDateSelected($event)" name="datepicker"
          [startDate]="minDepatureDate" [outsideDays]="'hidden'" [navigation]="'arrows'" [minDate]="minDepatureDate"
          [maxDate]="maxDepatureDate" [markDisabled]="datePickerDisabled" [hidden]="" tabindex="-1" [autoClose]="true"
          class="date-picker" />
      </div>
      <!-- Depart date ends here -->
      <div class="vr"></div>
      <!-- Arrival date starts here -->
      <!-- <div class="search-text">
          <p>Arrive</p>
          <p class="arrival-date">Select Date</p>
          <p>Day of the week</p>
        </div> -->
      <!-- Arrival date ends here -->
    </div>
    <div class="passenger-options">
      <div ngbDropdown>
        <div ngbDropdownToggle class="search-text">
          <p>Passenger</p>
          <p>
            {{ adult?.value + minor?.value }} Guest
            <span>
              <img src="/assets/landing-page-assets/ArrowUp.svg" alt="increase arrow buttons" alt="" /></span>
          </p>
          <p>
            {{ form.value.price }}
          </p>
        </div>
        @if (readonly == false) {
        <div class="passenger-dropdown" ngbDropdownMenu>
          <h6 class="dropdown-header">No. of Adults</h6>
          <div class="col-md-8 d-flex justify-content-between align-items-center">
            <button type="button" (click)="onDecreaseAdults()" class="btn">
              <img src="../../../../assets/minus-btn.svg" alt="decrease arrow buttons" class="img-fluid" />
            </button>
            <p class="mb-0">{{ adult?.value }}</p>
            <button (click)="onIncreaseAdults()" type="button" class="btn">
              <img src="../../../../assets/add-btn.svg" alt="add buttons" class="img-fluid" />
            </button>
          </div>
          <h6 class="dropdown-header">No. of Minors, Age 3 to 15</h6>
          <div class="col-md-8 d-flex justify-content-between align-items-center mb-3">
            <button type="button" (click)="onDecreaseMinors()" class="btn">
              <img src="../../../../assets/minus-btn.svg" alt=" minus-buttons" class="img-fluid" />
            </button>
            <p class="mb-0">{{ minor?.value }}</p>
            <button (click)="onIncreaseMinors()" type="button" class="btn">
              <img src="../../../../assets/add-btn.svg" alt="add button" class="img-fluid" />
            </button>
          </div>
          <ul class="list-group list-group-flush">
            @for (price of prices; track price; let i = $index) {
            <li class="list-group-item">
              <label class="form-check-label d-flex align-items-center justify-content-between" for="pricelist-{{ i }}"
                role="button">{{ price.name | uppercase }}
                <input formControlName="price" class="form-check-input" role="button" [value]="price.name" type="radio"
                  name="price" id="pricelist-{{ i }}" /></label>
            </li>
            }
          </ul>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <div class="action button-1">
    @if (readonly) {
    <button type="button" (click)="onModify()">Modify</button>
    } @else {
    <button type="button" (click)="onSearchAvailableTrains()">
      Search Ticket
    </button>
    }
  </div>
</form>

<!-- <div *ngIf="gettingSearchResults == false">
  <app-search-results (tripSelected)="updateSearchParams()" [searchParams]="form.value"
  [searchResults]="searchResults"></app-search-results>
</div> -->